// Loading skeleton components
export function ListingCardSkeleton() {
  return (
    <div className="bg-[var(--card)] rounded-xl sm:rounded-2xl border border-[var(--border)] overflow-hidden shadow-sm animate-pulse">
      <div className="h-40 sm:h-48 md:h-56 bg-[var(--bg)]" />
      <div className="p-2 sm:p-3 md:p-4 lg:p-5 space-y-1.5 sm:space-y-2 md:space-y-3">
        <div className="h-3 sm:h-4 md:h-5 bg-[var(--bg)] rounded w-3/4" />
        <div className="h-2.5 sm:h-3 md:h-4 bg-[var(--bg)] rounded w-1/2" />
        <div className="h-4 sm:h-5 md:h-6 bg-[var(--bg)] rounded w-1/3" />
      </div>
    </div>
  );
}

export function ListingGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 sm:gap-3 md:gap-4 lg:gap-6">
      {Array.from({ length: count }).map((_, i) => (
        <ListingCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function ChatMessageSkeleton() {
  return (
    <div className="flex gap-3 animate-pulse">
      <div className="h-10 w-10 rounded-full bg-[var(--bg)] flex-shrink-0" />
      <div className="flex-1 space-y-2">
        <div className="h-4 bg-[var(--bg)] rounded w-1/4" />
        <div className="h-16 bg-[var(--bg)] rounded-lg" />
      </div>
    </div>
  );
}

export function ChatListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex gap-3 p-3 rounded-xl bg-[var(--card)] border border-[var(--border)] animate-pulse">
          <div className="h-12 w-12 rounded-full bg-[var(--bg)] flex-shrink-0" />
          <div className="flex-1 space-y-2">
            <div className="h-4 bg-[var(--bg)] rounded w-1/3" />
            <div className="h-3 bg-[var(--bg)] rounded w-2/3" />
          </div>
        </div>
      ))}
    </div>
  );
}
